import { render, staticRenderFns } from "./V5GedungBangunanDiatasTanahMilik.vue?vue&type=template&id=5314459e&"
import script from "./V5GedungBangunanDiatasTanahMilik.vue?vue&type=script&lang=js&"
export * from "./V5GedungBangunanDiatasTanahMilik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports